import {
  Component,
  ChangeDetectionStrategy,
  Input,
  EventEmitter,
  Output,
  SimpleChanges,
  OnChanges,
  OnDestroy,
} from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { ChartTypes } from '@mode/shared/contract-common';
import { Subscription } from 'rxjs';
import { FormatListItem } from '../format-list-item';

interface LegendPosition {
  name: string;
  value: ChartTypes.LegendPosition;
}

const LEGEND_DEFAULTS = {
  title: '',
  show: true,
  position: 'auto',
  showTitle: true,
} as const;
@Component({
  selector: 'mode-format-builder-legend',
  templateUrl: './legend.component.html',
  styleUrls: ['./legend.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LegendComponent implements OnChanges, OnDestroy {
  @Input() legend!: ChartTypes.LegendFieldFormat;
  @Input() field!: FormatListItem;
  @Output() update = new EventEmitter<ChartTypes.LegendFieldFormat>();

  form = this.fb.group({
    title: ['', { updateOn: 'blur' }],
    show: [true],
    position: ['auto'],
    showTitle: [true],
  });
  subscription: Subscription;
  legendPositions: LegendPosition[] = [
    { name: 'Auto', value: 'auto' },
    { name: 'Top', value: 'top' },
    { name: 'Right', value: 'right' },
    { name: 'Bottom', value: 'bottom' },
    { name: 'Left', value: 'left' },
  ];
  currentPosition: LegendPosition = this.legendPositions[0];

  constructor(private fb: UntypedFormBuilder) {
    this.subscription = this.form.valueChanges.subscribe((legend: ChartTypes.LegendFieldFormat) => {
      this.update.emit(legend);
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.legend) {
      this.form.patchValue({ ...LEGEND_DEFAULTS, ...changes.legend.currentValue }, { emitEvent: false });
      this.currentPosition =
        this.legendPositions.find((p) => p.value === this.legend?.position) ?? this.legendPositions[0];
    }
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  selectPosition(legendPosition: LegendPosition) {
    this.currentPosition = legendPosition;
    this.form.patchValue({
      position: legendPosition.value,
    });
  }
}
